/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Rate_TtsInputs */



/**
* | output |
* | --- |
* | "$0.000050 / char" |
*
* @param {Usage_Rate_TtsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_rate_tts = /** @type {((inputs?: Usage_Rate_TtsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Rate_TtsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("0,000050 $ / caractère")
	if (locale === "de") return /** @type {LocalizedString} */ ("0,000050 $ / Zeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("$0,000050 / carattere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("0,000050 долл. США / символ")
	if (locale === "es") return /** @type {LocalizedString} */ ("$0.000050 / carácter")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("$0.000050/字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("0.000050ドル / 文字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("$0.000050 / चार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("$0,000050 / caractere")
	return /** @type {LocalizedString} */ ("$0.000050 / char")
});